import { render, staticRenderFns } from "./color-select.vue?vue&type=template&id=252215db&scoped=true"
import script from "./color-select.vue?vue&type=script&lang=ts"
export * from "./color-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252215db",
  null
  
)

export default component.exports